import type { CountdownStage } from '../types';

export const manifest = {
  id: 'gcam-default-v1',
  name: 'G-Camera Default',
  version: '1.0.0',
  description: '預設機能 HUD 拍照體驗',
} as const;

export const countdown: CountdownStage[] = [
  { value: '3', effect: 'particle', duration: 680 },
  { value: '2', effect: 'thermal', duration: 680 },
  { value: '1', effect: 'dither', duration: 680 },
  { value: 'G', effect: 'flash', duration: 220 },
];
